/* eslint-disable tailwindcss/no-custom-classname */
import {
  As,
  PropsOf,
  chakra,
  forwardRef,
  useCardStyles,
} from '@chakra-ui/react';
import React from 'react';

export type CardHeaderControlProps<Component extends As = 'div'> =
  PropsOf<Component>;

export const CardHeaderControl = forwardRef<CardHeaderControlProps, 'div'>(
  ({ className, ...props }, ref) => {
    const styles = useCardStyles();

    return (
      <chakra.div className="orbit-card__header-control" ref={ref}>
        <chakra.div
          {...props}
          className={className}
          __css={styles.headerControl}
        />
      </chakra.div>
    );
  },
);
